import { SnCollection } from '@lib/common/models';

import { SnChannel } from './channel.model';

export class SnChannelCollection extends SnCollection<SnChannel> {
  constructor(...items: SnChannel[]) {
    super(...items);

    Object.setPrototypeOf(this, SnChannelCollection.prototype);
  }

  public getBySid(sid: string): SnChannel {
    return this.find((channel: SnChannel) => channel.sid === sid);
  }
}
